import { LangText } from '@/components';

/** 领券中心 — 注意事项（快捷入口） */
export default function CouponPrecautions() {
  return (
    <div className="min-h-[calc(100vh-var(--spacing)*45)] bg-white">
      <div className="mx-auto max-w-2xl px-6 py-10 md:px-10">
        <h1 className="text-[24px] md:text-[28px] font-bold text-[#1a1a1a] mb-8">
          <LangText lngKey="487853f3" />
        </h1>
        <ul className="list-disc space-y-4 pl-5 text-[15px] leading-relaxed text-[#333333]">
          <li>
            <LangText lngKey="285ac4c0" />
          </li>
          <li>
            <LangText lngKey="4090e139" />
          </li>
          <li>
            <LangText lngKey="05bb367d" />
          </li>
        </ul>
      </div>
    </div>
  );
}
